<div class="d-flex flex-column justify-content-center align-items-center h-100 w-100" *ngIf="isLoading">
  <div class="spinner-border mr-50 mb-1" style="width: 3.5rem; height: 3.5rem; color: rgba(31, 88, 42, 1);" role="status">
  </div>
  <span>{{'APP.PROCESSING' | translate}}</span>
</div>
